import { render } from "./IconCard.vue?vue&type=template&id=6d282b86&scoped=true"
import script from "./IconCard.vue?vue&type=script&lang=js"
export * from "./IconCard.vue?vue&type=script&lang=js"

import "./IconCard.vue?vue&type=style&index=0&id=6d282b86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d282b86"]])

export default __exports__